var ceil = Math.ceil;
var floor = Math.floor; // `Math.trunc` method
// https://tc39.github.io/ecma262/#sec-math.trunc

require('../internals/export')({
  target: 'Math',
  stat: true
}, {
  trunc: function trunc(it) {
    return (it > 0 ? floor : ceil)(it);
  }
});